import * as React from 'react'
import classNames from 'classnames'

import type { Image } from 'types'
import Kicker from '../../00-Primitives/Kicker'
import Paragraph from 'content-components/_Primatives/Paragraph'
import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import Ruler from '../../00-Primitives/Ruler'
import { InlineImage } from 'content-components/_Primatives/Images'

import style from './style.scss'

export type CardVariants = 'light' | 'dark'

export type Props = {
  bodyText: string
  className?: string
  headlineText: string
  image?: Image
  kickerText?: string
  number?: number
  variant?: CardVariants
  variantColor?: 'black' | 'white' | 'red' | 'blue' | 'gray' | 'thin-light-gray'
  rulerColor: 'black' | 'white' | 'red' | 'blue' | 'gray' | 'thin-light-gray'
  isGradient?: boolean
  showNumber: boolean
}

function MessageCard(props: Props) {
  const {
    bodyText,
    className,
    headlineText,
    kickerText,
    number,
    variant = 'dark',
    image,
    rulerColor,
    isGradient = false,
    showNumber,
  } = props

  return (
    <li className={classNames(style.wrapper, style[variant], className)}>
      {image && (
        <InlineImage
          className={style.image}
          gradient={isGradient}
          image={image}
        />
      )}
      <div className={style.inner}>
        {showNumber ||
          (kickerText && (
            <div className={style.badgeWrapper}>
              {number && (
                <span className={classNames(style.badge, style[rulerColor])}>
                  {number}
                </span>
              )}
              {kickerText && (
                <Kicker className={style.kickerText}>{kickerText}</Kicker>
              )}
            </div>
          ))}
        <HeadlineTwo className={classNames(style.spacing, style.headline)}>
          {headlineText}
        </HeadlineTwo>
        <Ruler className={style.spacing} kind={rulerColor} />
        <Paragraph className={classNames(style.spacing, style.paragraph)}>
          {bodyText}
        </Paragraph>
      </div>
    </li>
  )
}

export default MessageCard
